import React, { useEffect, useState } from "react";
import "./styles/style.css";
import IntentConfirmationPopup from "./IntentConfirm";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import Footer from "./components/Footer";
import ChatMessages from "./components/ChatMessages";
import ChatComposer from "./components/ChatComposer";

const API_URL = process.env.REACT_APP_API_URL || "https://askhr.sltdigitallab.lk/api";
const CHAT_URL = "https://askhr.sltdigitallab.lk/api/v1/chat";
const CONFIRM_URL = "https://askhr.sltdigitallab.lk/api/v1/chat/confirm";

// const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5003/api";
// const CHAT_URL = "http://localhost:5003/api/v1/chat";
// const CONFIRM_URL = "http://localhost:5003/api/v1/chat/confirm";

const Home = () => {
  const [checkingAuth, setCheckingAuth] = useState(true);
  const [user, setUser] = useState(null);

  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [sending, setSending] = useState(false);
  const [confirmationData, setConfirmationData] = useState(null);
  const [pendingQuery, setPendingQuery] = useState(null);
  const [isConfirming, setIsConfirming] = useState(false);

  // stable chat_id per session
  const [chatId] = useState(
    () =>
      (window.crypto &&
        window.crypto.randomUUID &&
        window.crypto.randomUUID()) ||
      `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`
  );

  // // Scroll to bottom when messages change
  // useEffect(() => {
  //   endRef.current?.scrollIntoView({ behavior: "smooth" });
  // }, [messages]);

  // Check auth once
  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API_URL}/welcome`, {
          credentials: "include",
        });
        if (!res.ok) throw new Error("Auth check failed");
        const data = await res.json();
        setUser(data?.authenticated ? data : null);
      } catch {
        setUser(null);
      } finally {
        setCheckingAuth(false);
      }
    })();
  }, []);

  // Send message handler with confirmation support
  // Update the sendMessage function to properly handle confirmation

  const sendMessage = async () => {
    const text = input.trim();
    if (!text || sending) return;

    // Optimistic append of user message
    setMessages((m) => [...m, { role: "user", text }]);
    setInput("");
    setSending(true);

    try {
      const res = await fetch(CHAT_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ query: text, chat_id: chatId }),
      });

      if (res.ok) {
        const data = await res.json();

        console.log("Backend response:", data);
        console.log("intent_confirmation:", data.intent_confirmation);
        console.log("answer:", data.answer);

        const needsConfirmation = data?.intent_confirmation?.needs_confirmation === true;

        console.log("Needs confirmation?", needsConfirmation);

        if (needsConfirmation) {
          console.log("SHOWING POPUP - Setting confirmationData");
          console.log("Popup data:", data.intent_confirmation);
          setConfirmationData(data.intent_confirmation);
          setPendingQuery(text);

          return;
        }

        if (data?.answer && data.answer.trim()) {
          console.log("Normal answer received:", data.answer.substring(0, 100));
          setMessages((m) => [...m, { role: "assistant", text: data.answer }]);
        } else {
          console.warn("No answer and no confirmation in response");
          console.warn("Full response:", data);
          setMessages((m) => [
            ...m,
            { role: "assistant", text: "I received your message but couldn't generate a response. Please try again." }
          ]);
        }

      } else {
        console.error("Response not OK:", res.status);
        const errorText = await res.text();
        console.error("Error text:", errorText);
        setMessages((m) => [
          ...m,
          {
            role: "assistant",
            text: "I couldn't reach the chat API. Please try again.",
          },
        ]);
      }
    } catch (error) {
      console.error("Error sending message:", error);
      setMessages((m) => [
        ...m,
        {
          role: "assistant",
          text: "Network error. Please check your connection and try again.",
        },
      ]);
    } finally {
      setSending(false);
    }
  };



  const handleConfirmation = async (selectedOption) => {
    console.log("User confirmed:", selectedOption);

    setConfirmationData(null);

    const queryToSend = pendingQuery;
    setPendingQuery(null);

    setSending(true);

    console.log("Sending to:", CONFIRM_URL);
    console.log("Payload:", { chat_id: chatId, original_query: queryToSend, selected_option: selectedOption });

    try {
      const res = await fetch(CONFIRM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          chat_id: chatId,
          original_query: queryToSend,
          selected_option: selectedOption,
        }),
      });

      console.log("Confirmation response status:", res.status);

      if (res.ok) {
        const data = await res.json();
        console.log("Confirmation response data:", data);

        if (data?.answer) {
          setMessages((m) => [...m, { role: "assistant", text: data.answer }]);
        } else {
          console.warn("No answer in confirmation response");
        }
      } else {
        const errorText = await res.text();
        console.error("Confirmation failed:", errorText);
        setMessages((m) => [
          ...m,
          {
            role: "assistant",
            text: "Sorry, an error occurred processing your selection. Please try again.",
          },
        ]);
      }
    } catch (error) {
      console.error("Error confirming intent:", error);
      setMessages((m) => [
        ...m,
        {
          role: "assistant",
          text: "Network error during confirmation. Please try again.",
        },
      ]);
    } finally {
      setSending(false);
    }
  };

  const handleCancel = () => {
    console.log("User cancelled confirmation");
    setConfirmationData(null);
    setPendingQuery(null);
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-[#4a0080] via-[#6a0dad] to-black text-slate-100">
      <Header apiUrl={API_URL} checkingAuth={checkingAuth} user={user} />

      <main className="flex-1 flex flex-col items-center text-center gap-3 px-4 py-4 max-w-5xl mx-auto w-full">
        <HeroSection />

        <section className="w-full max-w-4xl h-[400px] max-h-[500px] mx-auto rounded-2xl bg-white/95 border border-white/60 shadow-2xl backdrop-blur-xl overflow-hidden flex flex-col">
          <div className="relative flex-1 flex flex-col min-h-0 bg-gradient-to-b from-white to-slate-50">
            {!user && !checkingAuth && (
              <div className="absolute inset-0 grid place-items-center gap-6 bg-white/95 rounded-b-2xl text-slate-700 shadow-lg">
                <span>Please log in with Microsoft to continue</span>
              </div>
            )}

            {user && (
              <div className="flex flex-col h-full bg-white">
                <ChatMessages
                  messages={messages}
                  setMessages={setMessages}
                  apiUrl={API_URL}
                  chatId={chatId}
                  user={user}
                />
                <ChatComposer
                  input={input}
                  setInput={setInput}
                  sending={sending}
                  onKeyDown={onKeyDown}
                  onSend={sendMessage}
                />
              </div>
            )}
          </div>
        </section>
      </main>

      {/* Intent Confirmation Popup */}
      <IntentConfirmationPopup
        confirmationData={confirmationData}
        onConfirm={handleConfirmation}
        onCancel={handleCancel}
        isSubmitting={isConfirming}
      />

      <Footer />
    </div>
  );
};

export default Home;